document.addEventListener("DOMContentLoaded", function () {

  function updateServingPrice() {

    const servingBox = document.querySelector('[data-serving-info]');
    if (!servingBox) return;


    // Check selected variant
    const variantData = document.querySelector('[data-js-variant-data]');

    if (!variantData) return;

    const variant = JSON.parse(variantData.textContent);


    // Only for 30-Pack
    if (!variant.title.includes("30-Pack")) {
      servingBox.innerHTML = "";
      return;
    }


    // Check subscription selection
    const selectedPurchase = document.querySelector(
      'input[data-radio-type]:checked'
    );


    if (!selectedPurchase) {
      servingBox.innerHTML = "";
      return;
    }


    let price = selectedPurchase.getAttribute(
      "data-variant-price"
    );


    if (!price) return;


    // Remove currency
    price = parseFloat(
      price.replace("$","").replace(" USD","")
    );


    // Divide by 30 packs
    let servingPrice = (price / 30).toFixed(2);


    servingBox.innerHTML = `
      <div class="serving-price">
        $${servingPrice} / serving
      </div>
      <div class="serving-text">
         30-pack saves $51.55 versus buying 30 singles.
      </div>
    `;

  }


  // Initial load
  updateServingPrice();


  // Variant change (30-Pack / Single)
  document.addEventListener(
    "change",
    function(e){

      if(
        e.target.matches(
          'input[data-radio-type], input[type="radio"], select'
        )
      ){
        setTimeout(updateServingPrice,300);
      }

    }
  );


});

document.addEventListener("DOMContentLoaded", function () {

  function updateBottleInfo() {

    const servingBox = document.querySelector('[data-serving-info]');
    if (!servingBox) return;

    const selectedPack = document.querySelector(
      '.swatch-view-item[orig-value][aria-checked="true"]'
    );

    if (!selectedPack) return;

    const packValue = selectedPack.getAttribute("orig-value");

    let content = "";

    if (packValue === "1 bottle") {

      content = `
        <div class="serving-price">
          1 bottle price $37.95
        </div>
      `;

    } else if (packValue === "2 bottles") {

      content = `
        <div class="serving-price">
          $34.98 each, save $5.95
        </div>
      `;

    } else if (packValue === "3 bottles") {

      content = `
        <div class="serving-price">
          $33.32 each, save $13.90
        </div>
      `;

    }

    servingBox.innerHTML = content;
  }


  /* =========================================
     INITIAL LOAD
  ========================================= */

  // Try immediately
  updateBottleInfo();

  // Swatch King may load after page load
  setTimeout(updateBottleInfo, 300);
  setTimeout(updateBottleInfo, 600);
  setTimeout(updateBottleInfo, 1000);
  setTimeout(updateBottleInfo, 1500);
  setTimeout(updateBottleInfo, 2000);


  /* =========================================
     BOTTLE SWATCH CLICK
  ========================================= */

  document.addEventListener("click", function (e) {

    const swatch = e.target.closest(
      '.swatch-view-item[orig-value]'
    );

    if (!swatch) return;

    const value = swatch.getAttribute("orig-value");

    if (
      value !== "1 bottle" &&
      value !== "2 bottles" &&
      value !== "3 bottles"
    ) {
      return;
    }

    setTimeout(updateBottleInfo, 300);
  });


  /* =========================================
     CHANGE EVENT
  ========================================= */

  document.addEventListener("change", function (e) {

    if (
      e.target.matches(
        'input[data-radio-type], input[type="radio"], select'
      )
    ) {
      setTimeout(updateBottleInfo, 300);
    }

  });


  /* =========================================
     WATCH SWATCH KING
  ========================================= */

  function observeSwatches() {

    const swatchWrapper = document.querySelector(
      "variant-swatch-king"
    );

    if (!swatchWrapper) {
      setTimeout(observeSwatches, 500);
      return;
    }

    const observer = new MutationObserver(function () {
      updateBottleInfo();
    });

    observer.observe(swatchWrapper, {
      attributes: true,
      attributeFilter: ["aria-checked", "class"],
      childList: true,
      subtree: true
    });

  }

  observeSwatches();

});

document.addEventListener("DOMContentLoaded", function () {

  /* =========================================
     BEST VALUE BADGE
     30-Pack + 3 bottles
  ========================================= */

  function addBestValueBadges() {

    const bestValueOptions = [
      "30-Pack",
      "3 bottles"
    ];

    bestValueOptions.forEach(function (value) {

      const pack = document.querySelector(
        '.swatch-view-item[orig-value="' + value + '"]'
      );

      if (!pack) return;

      // Prevent duplicate badge
      if (pack.querySelector(".best-value-badge")) return;

      // Add badge OUTSIDE swatch-button
      pack.insertAdjacentHTML(
        "beforeend",
        '<span class="best-value-badge">BEST VALUE</span>'
      );

    });

  }


  /* =========================================
     UPDATE VARIANT PRICE
  ========================================= */

  function updateVariantPrice() {

    const variantData = document.querySelector(
      '[data-js-variant-data]'
    );

    const priceBox = document.querySelector(
      '[data-variant-real-price]'
    );

    if (!variantData || !priceBox) return;

    let variant;

    try {
      variant = JSON.parse(
        variantData.textContent
      );
    } catch (error) {
      return;
    }

    if (!variant || !variant.price) return;

    priceBox.innerHTML = `
      <div class="variant-current-price">
        ${Shopify.formatMoney(
          variant.price,
          "{{ shop.money_format }}"
        )}
      </div>
    `;

  }


  /* =========================================
     INITIAL LOAD
  ========================================= */

  addBestValueBadges();
  updateVariantPrice();


  /* =========================================
     VARIANT CHANGE
  ========================================= */

  document.addEventListener("change", function () {

    setTimeout(function () {

      addBestValueBadges();
      updateVariantPrice();

    }, 300);

  });


  /* =========================================
     SWATCH KING RE-RENDER
  ========================================= */

  function observeSwatches() {

    const swatchWrapper = document.querySelector(
      "variant-swatch-king"
    );

    if (!swatchWrapper) return;

    const observer = new MutationObserver(function () {

      addBestValueBadges();

    });

    observer.observe(swatchWrapper, {
      childList: true,
      subtree: true
    });

  }

  observeSwatches();


  /* =========================================
     FALLBACK FOR APP LOADING
  ========================================= */

  setTimeout(addBestValueBadges, 500);
  setTimeout(addBestValueBadges, 1000);
  setTimeout(addBestValueBadges, 2000);
  setTimeout(addBestValueBadges, 3000);

});

document.addEventListener("DOMContentLoaded", function () {

    let selectedPurchaseType = null;

    function getPriceBox() {
        return document.querySelector(
            '[data-update-block="price-compact"] .product-price--original'
        );
    }


    /* =========================================
       PURCHASE OPTION CHANGE
    ========================================= */

    document.addEventListener("change", function (e) {

        const option = e.target.closest(
            '.plan_card input[type="radio"]'
        );

        if (!option) return;


        // Remember selected option
        selectedPurchaseType =
            option.getAttribute("data-radio-type");


        const newPrice =
            option.getAttribute("data-variant-price");


        if (!newPrice) return;


        const priceBox = getPriceBox();

        if (!priceBox) return;


        // Same behavior as your original code
        priceBox.textContent = newPrice;

    });


    /* =========================================
       BOTTLE / VARIANT CHANGE
       ========================================= */

    document.addEventListener("click", function (e) {

        const swatch = e.target.closest(
            ".swatch-view-item, .swatch-button"
        );

        if (!swatch) return;


        const variantName =
            swatch.getAttribute("orig-value") ||
            swatch.getAttribute("data-value") ||
            swatch.getAttribute("aria-label");


        /*
         * Only do something when returning
         * to 1 Bottle.
         */

        if (variantName !== "1 Bottle") {
            return;
        }


        /*
         * Wait for the new 1 Bottle variant
         * to finish loading.
         */

        

            if (!selectedPurchaseType) return;


            const selectedOption = document.querySelector(
                '.plan_card input[type="radio"][data-radio-type="' +
                selectedPurchaseType +
                '"]'
            );


            if (!selectedOption) return;


            const newPrice =
                selectedOption.getAttribute("data-variant-price");


            if (!newPrice) return;


            const priceBox = getPriceBox();

            if (!priceBox) return;


            /*
             * Now apply the 1 Bottle price
             * according to the previously selected
             * purchase option.
             */

            priceBox.textContent = newPrice;


      

    });


    /* =========================================
       INITIAL SELECTED OPTION
       ========================================= */

    const initiallyChecked = document.querySelector(
        '.plan_card input[type="radio"]:checked'
    );


    if (initiallyChecked) {

        selectedPurchaseType =
            initiallyChecked.getAttribute("data-radio-type");

    }

});